import React from 'react'
import { useHistory } from 'react-router-dom'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { useApiFormAppVersion } from '../../../../../../api-new/state/config'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitCreate } from '../../../../../../shared/form-simple/form-submit'

export const AppVersionAdd = () => {
  const history = useHistory()

  const { appID, appStoreID } = useParamsInt()

  const apiFormAppVersion = useApiFormAppVersion()

  const roleSysApp = useRoleSysApp()

  const handleSubmit = async data => {
    let appVersion = await apiFormAppVersion.post(data)
    if (roleSysApp.accessUpdate) history.push(`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/edit/${appVersion.id}`)
    else history.push(`/admin/app/edit/${appID}/store/edit/${appStoreID}/version`)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text="Add app store version">
        <CardFullHeightScrollY title="add app store version">
          <FormSimple onSubmit={handleSubmit}>
            <FormSimpleHiddenNumber name="appStoreID" value={appStoreID} />
            <FormSimpleText name="name" required autoFocus />
            <FormSimpleSubmitCreate />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
